import React from 'react';
import { YES_NO_OPTIONS } from 'constants/commonOptions';
import FormControl from 'components/FormControl';
import styles from '../../FormSection.module.scss';
import ChoiceInput from 'components/Inputs/ChoiceInput';
import { translateText } from 'utils/i18n';

interface Props {
  value?: any;
  onChange: (item: any) => void;
}

const AdditionalParking: React.FC<Props> = ({ value, onChange }) => {
  return (
    <FormControl
      wrapperClassName={styles['form-row']}
      label={translateText(
        'avantPlatform.attributes.lease.label.additionalParking',
      )}
    >
      <ChoiceInput
        labelFieldName="id"
        selectedItem={{ name: value.additionalParking }}
        data={YES_NO_OPTIONS}
        containerWrapperClassName={styles['radio-input-container']}
        onChange={onChange}
      />
    </FormControl>
  );
};

export default AdditionalParking;
